import { Typography } from '@sureco/design-system'
import React, { memo } from 'react'

function AnalyzeSummary({ data }) {
  const summary = data
    ? data.reduce(
        (acc, row) => {
          if (row.diffStatus === 'NEW') acc.new += 1
          if (row.diffStatus === 'CHANGED') acc.changed += 1
          if (row.diffStatus === 'DELETED') acc.deleted += 1
          if (row.diffStatus === 'UNCHANGED') acc.unchanged += 1
          acc.total += 1

          return acc
        },
        { new: 0, changed: 0, deleted: 0, unchanged: 0, total: 0 }
      )
    : { new: 0, changed: 0, deleted: 0, unchanged: 0, total: 0 }

  return (
    <Typography as="h3" size={20}>
      New: {summary.new}, Changed: {summary.changed}, Deleted: {summary.deleted}
      , Unchanged: {summary.unchanged}, Total: {summary.total}
    </Typography>
  )
}

export default memo(AnalyzeSummary)
